module.exports = __webpack_public_path__ + "img/pneu.9fe6c15d.svg";